import { Component, OnInit } from '@angular/core';
import { NgbDateNativeAdapter, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Chart } from 'chart.js';
import { ReportService } from 'src/app/services/report.service';
import { DashboardManager } from 'src/app/classes/dashboard-manager';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class DashboardComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  chartByTon: any;
  chartByExpenses: any;
  chartByGas: any;
  chartByMarket: any;
  chartByUtility: any;
  realType:string = 'unity';
  loading:boolean = false;

  constructor(private reportServ:ReportService, private dashboard:DashboardManager) { }
  
  ngOnInit() {
    this.chartByTon = new Chart('byTon', {
      type: 'bar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        title: {
          display: true,
          text: 'TONELADAS'
        },
      },
    });

    this.chartByGas = new Chart('byGas', {
      type: 'bar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        title: {
          display: true,
          text: 'COMBUSTIBLE'
        },
      },
    });

    this.chartByMarket = new Chart('byMarket', {
      type: 'bar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        title: {
          display: true,
          text: 'TOTAL COSTO MERCADO'
        },
      },
    });

    this.chartByUtility = new Chart('byUtility', {
      type: 'bar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        title: {
          display: true,
          text: 'UTILIDAD'
        },
      },
    });

    this.chartByExpenses = new Chart('byExpenses', {
      type: 'bar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        title: {
          display: true,
          text: 'GASTOS TOTALES'
        },
      },
    });
  }
  
  search() {
    this.loading = true;
    this.reportServ.totalExpensesReport(this.date1, this.date2, this.realType).then(result => {
      this.dashboard.setData(result);
      this.dashboard.getTotals();

      this.chartByTon.data.labels = this.dashboard.labels; 
      this.chartByTon.data.datasets = this.dashboard.datasets.ton;
      this.chartByExpenses.data.labels = this.dashboard.labels; 
      this.chartByExpenses.data.datasets = this.dashboard.datasets.expenses;
      this.chartByGas.data.labels = this.dashboard.labels; 
      this.chartByGas.data.datasets = this.dashboard.datasets.gas;
      this.chartByMarket.data.labels = this.dashboard.labels; 
      this.chartByMarket.data.datasets = this.dashboard.datasets.market;
      this.chartByUtility.data.labels = this.dashboard.labels; 
      this.chartByUtility.data.datasets = this.dashboard.datasets.utility;

      this.chartByTon.update();
      this.chartByExpenses.update();
      this.chartByGas.update();
      this.chartByMarket.update();
      this.chartByUtility.update();
      this.loading = false;
    });
  }
}
